import React from "react";
import Heading from "../heading/Heading";
export var Loading = function Loading(_ref) {
  var isLoading = _ref.isLoading;
  return isLoading ? /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "cb-loading__rocker",
    role: "status"
  }), /*#__PURE__*/React.createElement(Heading, {
    level: 2,
    field: {
      value: "Loading..."
    },
    className: "cb-loading__text"
  }))) : null;
};